export default [
	{
		type: "special",
		id: 1,
		items: [
			{
				id: 1,
				text: "I became aware of the workshop through",
				label: [
					{
						id: 1,
						text: "ISZ Info-Mail",
					},
					{
						id: 2,
						text: "Facebook-Page of the UdS",
					},
					{
						id: 3,
						text: "Schlüsselkompetenzen-Programm Homepage",
					},
					{
						id: 4,
						text: "ISZ Homepage",
					},
					{
						id: 5,
						text: "Other ways, namely",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 2,
				text: "Other:",
				type: "medium",
			},
		],
	},
	{
		type: "special",
		id: 3,
		items: [
			{
				id: 3,
				text: "I am a",
				label: [
					{
						id: 1,
						text: "Bachelor student",
					},
					{
						id: 2,
						text: "Master student",
					},
					{
						id: 3,
						text: "Employee",
					},
					{
						id: 4,
						text: "Teacher",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 4,
				text: "Field of study",
				type: "medium",
			},
			{
				id: 5,
				text: "Your current semester (if student)",
				type: "small",
			},
			{
				id: 6,
				text: "Desired degree (if student)",
				type: "medium",
			},
		],
	},
	{
		type: "uni",
		id: 5,
		items: [
			{
				id: 7,
				text: "The scope of the course (duration, number of hours) was just right.",
			},
			{
				id: 8,
				text: "The amount of the content was just right.",
			},
			{
				id: 9,
				text: "The pace of the course was just right.",
			},
			{
				id: 10,
				text: "The difficulty level of the course (content and assignments) was just right.",
			},
			{
				id: 11,
				text: "The amount of work in the course was just right.",
			},
			{
				id: 12,
				text: "The assignments and exercises were clear and understandable.",
			},
			{
				id: 13,
				text: "The language level was just right. I was able to follow the course verbally well.",
			},
			{
				id: 14,
				text: "I understood what the goal of the course was.",
			},
			{
				id: 15,
				text: "The course was well structured. The order of the content was logical and made sense.",
			},
			{
				id: 16,
				text: "The ratio between theory and practice was balanced.",
			},
			{
				id: 17,
				text: "The practical importance of the topics became clear.",
			},
			{
				id: 18,
				text: "The ratio between individual and group work made sense.",
			},
			{
				id: 19,
				text: "The course had the right focus for me.",
			},
			{
				id: 20,
				text: "The exercises and assignments motivated me to think along and participate actively in the course.",
			},
			{
				id: 21,
				text: "The exercises and tasks helped me to understand the topic better.",
			},
			{
				id: 22,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 23,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 24,
				text: "The lecturer has always been well prepared.",
			},
			{
				id: 25,
				text: "The teacher was flexible and responded well to the wishes and needs of the participants.",
			},
			{
				id: 26,
				text: "The lecturer was very competent.",
			},
			{
				id: 27,
				text: "The teacher was able to explain well.",
			},
			{
				id: 28,
				text: "The teacher motivated me to participate, discuss, and ask questions.",
			},
			{
				id: 29,
				text: "The teacher helped with the tasks and exercises when necessary.",
			},
			{
				id: 30,
				text: "The course was useful and meaningful for my studies.",
			},
			{
				id: 31,
				text: "The course was helpful for my personal development.",
			},
			{
				id: 32,
				text: "I had the opportunity to reflect on my issues and concerns.",
			},
			{
				id: 33,
				text: "Through the course I gained knowledge and (further) developed competencies that I can practically apply (in my studies, everyday life and job).",
			},
			{
				id: 34,
				text: "I can now continue to work on the topic independently.",
			},
			{
				id: 35,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 36,
				text: "Overall, this was a good course.",
			},
			{
				id: 37,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [
			{
				id: 38,
				text: "What was particularly good? What did you like? What should stay the same?",
			},
			{
				id: 39,
				text: "What was not good? What did you not like? What should be changed?",
			},
			{
				id: 40,
				text: "Do you miss a course in our program? We are looking forward to your suggestions !",
			},
		],
	},
];
